export default __webpack_public_path__ + "static/media/EP03_ERYTHREE.7f7fb624.mp3";